<template>
  <div class="the-nav-bar type-body3">
    <div
      class="bg"
      ref="refBg"
    />

    <ul
      class="wrap menu-list desktop-only"
      ref="refItems"
      :class="{ hide: collapsed }"
    >
      <NavBarItem
        v-for="item in items"
        :key="item._uid"
        :item="item"
      />
      <!-- <div
        class="nav-bar-item"
        v-for="item in items"
        :key="item._uid"
      >
        <Cta :blok="item">
          <HoverReveal>
            <span class="label">{{ item.label }}</span>
          </HoverReveal>
        </Cta>
      </div> -->
    </ul>

    <button
      class="wrap menu-button"
      ref="refMenu"
      :class="{ hide: !collapsed }"
      @click="onMenuButtonClick"
    >
      <div class="label">
        <HoverReveal :hovering="hoveringMenu"> Menu </HoverReveal>
      </div>
      <IconHamburger class="icon" />
    </button>
  </div>
</template>

<script setup lang="ts">
import IconHamburger from "@/icons/hamburger.svg"
const props = defineProps({
  items: {
    type: Array,
    required: true,
  },
  collapsed: {
    type: Boolean,
  },
})

const emits = defineEmits([])

const { $gsap, $ScrollTrigger } = useNuxtApp()

const { app, debug, browser } = useStores()

const refRoot = ref(null)
const refBg = ref(null)
const refItems = ref(null)
const refMenu = ref(null)

const hoveringMenu = useElementHover(refMenu)

const env = useEnv()

// ************************************************************
// BG Width
// ************************************************************
const updateBgWidth = () => {
  let width = 0
  if (props.collapsed) {
    width = refMenu.value.offsetWidth
  } else {
    width = refItems.value.offsetWidth
  }
  $gsap.to(refBg.value, { width, duration: 0.4 })
}

watch(() => props.collapsed, updateBgWidth)

onMounted(updateBgWidth)

useResize2(updateBgWidth)

const onMenuButtonClick = () => {
  // if (env.isMobile) return
  // props.collapsed = false
  // console.log("onMenuButtonClick")
  app.setModalId("menu")
}
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";

.the-nav-bar {
  position: relative;
  display: block;
  white-space: nowrap;
  font-size: 1.5rem;
  font-weight: 400;
}

.bg {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  background: rgba(#545454, 0.5);
  backdrop-filter: blur(94px);
  border-radius: $p1;
  // transition: width 0.3s ease 0s;
}

.wrap {
  position: relative;
  @include flex(row, space-between, center);
  // gap: $p3;
  width: fit-content;
  height: var(--nav-bar-height);
  padding: 0 $p3 / 2;
  transition: opacity 0.3s ease 0.2s;

  &.menu-list {
    position: absolute;
    right: 0;
    top: 0;
  }

  &.menu-button {
    gap: 1.2rem;
    padding-inline: $p3;

    @include mobile {
      gap: 1rem;
      padding-inline: 1.8rem;
    }
  }

  &.hide {
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s ease 0s;
  }
}

:deep(.reveal-content) {
  @include gradientText();
}
</style>
